import type {University} from './types';
import {formatEnrollmentPeriod, formatUniversityInfo} from './utils';

export type UniversityInfoSectionProps = {
  university: University;
};

export const UniversityInfoSection: React.FC<UniversityInfoSectionProps> = ({
  university,
}) => {
  const universityInfo = formatUniversityInfo(
    university.major,
    university.subject,
    university.grade,
  );
  const enrollmentPeriod = formatEnrollmentPeriod(
    university.enrollYear,
    university.enrollMonth,
    university.graduateYear,
    university.graduateMonth,
  );

  return (
    <div className="flex flex-col gap-16 flex-1">
      <div>
        <div className="font-bold whitespace-nowrap">{university.name}</div>
        {universityInfo && <div className="text-base">{universityInfo}</div>}
      </div>
      {enrollmentPeriod && (
        <div>
          <div className="font-bold">在籍期間</div>
          <div className="text-base whitespace-nowrap">{`${enrollmentPeriod}（見込み）`}</div>
        </div>
      )}
    </div>
  );
};
